import { Play, Check, Heart, Plus, Clock, UserPlus, Bell, MoreHorizontal } from "lucide-react";

// ─── Neon Orb ─────────────────────────────────────────────────────────────────
export const NeonOrb = ({ style }) => (
  <div style={{
    position: "absolute",
    borderRadius: "50%",
    filter: "blur(80px)",
    pointerEvents: "none",
    ...style,
  }} />
);

// ─── Artist Card ──────────────────────────────────────────────────────────────
export const ArtistCard = ({ artist, onClick }) => (
  <div className="card-hover animate-up" onClick={() => onClick(artist)}
    style={{ textAlign: "center", padding: "20px 12px" }}>
    <div style={{ position: "relative", display: "inline-block", marginBottom: 12 }}>
      <img src={artist.img} alt={artist.name} style={{
        width: 100, height: 100, borderRadius: "50%", objectFit: "cover",
        border: "2px solid rgba(188,19,254,0.4)",
        boxShadow: "0 0 20px rgba(188,19,254,0.25)",
      }} />
      {artist.verified && (
        <div style={{
          position: "absolute", bottom: 4, right: 4,
          background: "#bc13fe", borderRadius: "50%", width: 22, height: 22,
          display: "flex", alignItems: "center", justifyContent: "center",
          boxShadow: "0 0 8px #bc13fe",
        }}>
          <Check size={12} color="#fff" />
        </div>
      )}
    </div>
    <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 4 }}>{artist.name}</div>
    <div style={{ color: "var(--text-dim)", fontSize: 12 }}>{artist.followers} followers</div>
    <div className="tag tag-neon" style={{ marginTop: 8 }}>{artist.genre}</div>
  </div>
);

// ─── Album Card ───────────────────────────────────────────────────────────────
export const AlbumCard = ({ album, onClick }) => (
  <div className="glass card-hover animate-up" onClick={() => onClick(album)}
    style={{ borderRadius: 16, overflow: "hidden" }}>
    <div style={{ position: "relative", overflow: "hidden" }}>
      <img src={album.img} alt={album.title}
        style={{ width: "100%", aspectRatio: "1", objectFit: "cover", display: "block" }} />
      <PlayOverlay />
    </div>
    <div style={{ padding: "14px" }}>
      <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 4, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        {album.title}
      </div>
      <div style={{ color: "var(--text-dim)", fontSize: 12 }}>{album.artist} · {album.year}</div>
    </div>
  </div>
);

// ─── Play Overlay (used inside AlbumCard) ─────────────────────────────────────
const PlayOverlay = () => (
  <div
    style={{
      position: "absolute", inset: 0,
      background: "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
      opacity: 0, transition: "opacity 0.2s",
      display: "flex", alignItems: "center", justifyContent: "center",
    }}
    onMouseEnter={e => (e.currentTarget.style.opacity = 1)}
    onMouseLeave={e => (e.currentTarget.style.opacity = 0)}>
    <div style={{
      width: 52, height: 52, borderRadius: "50%",
      background: "linear-gradient(135deg, #bc13fe, #7b00cc)",
      display: "flex", alignItems: "center", justifyContent: "center",
      boxShadow: "0 0 24px rgba(188,19,254,0.6)",
    }}>
      <Play size={22} color="#fff" fill="#fff" style={{ marginLeft: 3 }} />
    </div>
  </div>
);

// ─── Track Row ────────────────────────────────────────────────────────────────
export const TrackRow = ({ track, index, isPlaying, onPlay }) => (
  <div
    className={`track-row ${isPlaying ? "playing" : ""}`}
    style={{ gridTemplateColumns: "32px 40px 1fr 80px 80px" }}
    onClick={() => onPlay(track)}>
    {/* Index / EQ */}
    <span className="mono" style={{ color: "var(--text-dim)", fontSize: 13, textAlign: "center" }}>
      {isPlaying
        ? <span className="eq-bars"><span /><span /><span /></span>
        : index + 1}
    </span>
    {/* Thumbnail */}
    <img src={track.img} alt="" style={{ width: 36, height: 36, borderRadius: 6, objectFit: "cover" }} />
    {/* Info */}
    <div style={{ overflow: "hidden" }}>
      <div style={{
        fontWeight: 700, fontSize: 14,
        whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
        color: isPlaying ? "var(--neon)" : "var(--text)",
      }}>
        {track.title}
      </div>
      <div style={{ color: "var(--text-dim)", fontSize: 12 }}>{track.artist}</div>
    </div>
    {/* Plays */}
    <div style={{ color: "var(--text-dim)", fontSize: 12 }}>{track.plays}</div>
    {/* Duration */}
    <div className="mono" style={{ color: "var(--text-dim)", fontSize: 12, textAlign: "right" }}>
      {track.duration}
    </div>
  </div>
);

// ─── Section Title ────────────────────────────────────────────────────────────
export const SectionTitle = ({ icon: Icon, color, children, onMore }) => (
  <div className="section-title">
    {Icon && <Icon size={22} color={color} />}
    {children}
    {onMore && (
      <span
        style={{ marginLeft: "auto", cursor: "pointer", color: "var(--text-dim)" }}
        onClick={onMore}>
        ›
      </span>
    )}
  </div>
);
